import { COUNCILS } from '../councils';

// Aggregate Scotland requests must remain bounded when other regions go public.
export const SCOTTISH_READ_MODEL_COUNTRY = 'scotland';

export function confirmsScottishReadModelScope(payload: unknown): boolean {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return false;
  const value = payload as { scope?: unknown; applications?: unknown };
  if (!value.scope || typeof value.scope !== 'object' || Array.isArray(value.scope)) return false;
  const scope = value.scope as { country?: unknown; region?: unknown; public_authorities?: unknown };
  if (scope.country !== SCOTTISH_READ_MODEL_COUNTRY || scope.region != null || !Array.isArray(scope.public_authorities)) return false;
  const councils = new Set(Object.values(COUNCILS).filter(council => council.publicEnabled).map(council => String(council.slug)));
  const authorities = scope.public_authorities;
  if (authorities.length !== councils.size || new Set(authorities).size !== councils.size ||
      authorities.some(authority => typeof authority !== 'string' || !councils.has(authority))) return false;
  // Scope metadata and record identities must agree, including empty pages.
  return !Array.isArray(value.applications) || value.applications.every(record => (
    record && typeof record === 'object' &&
    (!record.source_council || councils.has(record.source_council))
  ));
}
